import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useDrag } from 'react-dnd';

// TODO: remove dependence on using the WHOLE seat object (onSelectGuest)
const SeatContent = ({
  index,
  partOfDrag,
  rsvpDeclined,
  seat,
  handlers,
}) => {
  const {
    onEndDrag,
    onSelectGuest,
    onRemoveSeat,
    onStartDrag
  } = handlers;

  const deleteSeat = (e) => {
    e.stopPropagation();
    onRemoveSeat(seat);
  };
  const isCouple = seat.couple_role !== null;

  const [, dragRef] = useDrag({
    item: { type: 'SEAT' },
    begin() {
      const key = isCouple ? seat.couple_role : seat.guest_id;
      onStartDrag([key]);
      return {
        item: 'seat',
        index,
        originalIndex: index,
        seat,
        displayName: seat.display_name,
        firstName: null,
        lastName: null
      };
    },
    end() { onEndDrag(); }
  });

  const hasDeclined = rsvpDeclined;

  const opacity = partOfDrag ? 0 : 1;
  const className = cx('sc__seat', {
    'sc__seat--is-dragged': partOfDrag,
  });
  const seatNameClassName = cx('sc__seat__guest-name', {
    'has-declined with-tooltip tooltip-top': hasDeclined,
  })

  return (
    <div
      className={className}
      onClick={() => onSelectGuest(seat, null, isCouple)}
      ref={node => dragRef(node)}
    >
      <div className="sc__seat-guest-number">{index + 1}.</div>
      <div
        className={seatNameClassName}
        data-tooltip="This guest has declined attending this event"
      >
        {!partOfDrag && seat.display_name}
        {hasDeclined && <span className="zolaicon zolaicon-clear-field" />}
      </div>
      <div className="sc__seat__delete-button" style={{ opacity }} onClick={e => deleteSeat(e)}>
        <i className="zolaicon zolaicon-close" />
      </div>
    </div>
  );
};

SeatContent.propTypes = {
  index: PropTypes.number,
  partOfDrag: PropTypes.bool,
  onRemoveSeat: PropTypes.func,
  onSelectGuest: PropTypes.func,
  rsvpDeclined: PropTypes.bool,
  seat: PropTypes.shape(null),
  handlers: PropTypes.shape({
    onEndDrag: PropTypes.func,
    onReceiveSeat: PropTypes.func,
    onRemoveSeat: PropTypes.func,
    onReorderSeat: PropTypes.func,
    onSelectGuest: PropTypes.func,
    onStartDrag: PropTypes.func,
  }),
};

export default SeatContent;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Tables/Seat/SeatContent.jsx